module.exports = __webpack_public_path__ + "assets/img/TechnicalBAPC.107d4b5f.png";